/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} True_Weird_Ladybug_SnapInputs */

const en_true_weird_ladybug_snap = /** @type {(inputs: True_Weird_Ladybug_SnapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {True_Weird_Ladybug_SnapInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const true_weird_ladybug_snap = /** @type {((inputs?: True_Weird_Ladybug_SnapInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<True_Weird_Ladybug_SnapInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_true_weird_ladybug_snap(inputs)
});